var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseButton',{staticClass:"button-upload",style:(_vm.style),attrs:{"disabled":_vm.disabled,"type":-1},on:{"click":function($event){_vm.$emit('click')}}},[_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.lang.text))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7839b60e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/button/UploadButton.vue
// module id = null
// module chunks = 